import { Typography } from '@mui/material'
import { CandidateMeQueryQuery } from '__generated__/graphql'
import TaskButton from 'candidate/components/TaskButton/TaskButton'
import { candidateRouteConfig } from 'candidate/routes'
import React from 'react'
import { ReactComponent as EmptyTasks } from 'shared/assets/new_empty_task.svg'
import DashboardCard from 'shared/components/DashboardCard'
import { EmptyStateContainer } from './styled'

interface Props {
    candidate: CandidateMeQueryQuery['candidateMe']
}

const TasksCard: React.FC<Props> = (candidate) => {
    const candidateIntakes = candidate.candidate.candidateIntakes
    const sortedIncompleteCandidateIntakes = candidateIntakes
        ?.filter((ci) => ci.completionDate === null)
        .sort(
            (a, b) =>
                (a?.intake?.intakePart?.order || 0) -
                (b?.intake?.intakePart?.order || 1)
        )

    return (
        <DashboardCard title="Tasks">
            <>
                {sortedIncompleteCandidateIntakes?.length === 0 ? (
                    <EmptyStateContainer>
                        <EmptyTasks />
                        <Typography variant="body1">
                            You currently have no tasks assigned.
                        </Typography>
                    </EmptyStateContainer>
                ) : (
                    sortedIncompleteCandidateIntakes?.map((ci) => (
                        <TaskButton
                            key={ci.id}
                            href={`${candidateRouteConfig.intakes.intake.path}/${ci.id}`}
                            displayName={
                                ci?.intake?.intakePart?.displayName || ''
                            }
                            isComplete={ci.completionDate !== null}
                        />
                    ))
                )}
            </>
        </DashboardCard>
    )
}

export default TasksCard
